/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { BaseComponent } from '../../core/components';
import { Component } from '@angular/core';
import { NavigationService, UserService } from '../../core/services';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss', '../externalPageStyles.scss']
})

export class ErrorComponent extends BaseComponent {
    /**
     * Displays the current year in the copyright and version footer.
     */
    public currentYear: number = new Date().getFullYear();

    /**
     * Page title.
     */
    public pageTitle: string;

    /**
     * Page sub-title.
     */
    public pageSubTitle: string;

    /**
     * Is this Endurance?
     * @type {boolean}
     */
    public isEndurance: boolean = false;

    constructor(
        public userService: UserService,
        private navigationService: NavigationService,
        private router: Router
    ) {
        super();

        this.isEndurance = this.environment.module === this.modulesEnum.LOADBALANCER;
        this.setUpPage(this.router.url);
    }

    /**
     * Send the user back a page or redirect to Dashboard / Overview.
     */
    public goBack(): void {
        if (this.navigationService.history.length > 1) {
            const no404 = this.navigationService.history.filter((item: string) => item !== '404');
            this.router.navigateByUrl(no404[0]).then().catch();
        } else {
            this.router.navigateByUrl(!this.isEndurance ? '/cm/dashboard' : '/').then().catch();
        }
    }

    /**
     * Empty url store and proceed to login page.
     */
    public goToLogin(): void {
        this.navigationService.redirectLocation = null;
        this.router.navigateByUrl('/login').then();
    }

    /**
     * Set up the page.
     * @param url
     * @private
     */
    private setUpPage(url: string): void {
        this.setPageTitle(url);
    }

    /**
     * Set the page title.
     * @param newUrl
     * @private
     */
    private setPageTitle(newUrl: string): void {
        switch (newUrl) {
            case '/404':
                this.pageTitle = '404';
                this.pageSubTitle = '404_page_not_found';
                break;
            case '/403':
                this.pageTitle = '403';
                this.pageSubTitle = '403_access_denied';
                break;
        }
    }
}
